import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { IconButton } from '../../components/ui';
import { ui } from '../../store/ui';

export function PanelHeader({ title, icon, actions }: { title: ReactNode; icon?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="flex h-12 shrink-0 items-center gap-2 border-b border-line px-3">
      {icon}
      <h2 className="min-w-0 flex-1 truncate font-semibold text-fg">{title}</h2>
      {actions}
      <IconButton icon={X} label="Close panel" onClick={() => ui.setRightPanel(null)} />
    </div>
  );
}
